import React from "react";
import { react } from "mobx";
import { inject, observer } from "mobx-react";
import {Button, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import {Component} from "react/lib/ReactBaseClasses";
import store from "../../../stores";
import loading from '../../../assets/images/ajax-loader.gif';
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";
import TabelaFiltroStore from "../stores/TabelaFiltroStore";
import qs from "query-string";

@inject("store")
@observer
class TabelaFiltro extends Component {

    static propTypes = {
        filterValues: PropTypes.object,
        carregarTabela: PropTypes.func,
        onExportExcel: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.modalStore = this.props.store.modalStore;
        this.controller = new TabelaFiltroStore(this.props.carregarTabela, this.props.history);
        this.validacaoStore = this.props.store.validacaoStore;
    }

    componentDidMount() {
        const params = qs.parse(this.props.location.search);

        this.props.carregarDadosDaUrl(params);
    }

    filtrar(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.store.formStore.setSubmitted(true);

        if(this.validacaoStore.isValidForm) {
            this.modalStore.closeModal('filtrar')
            this.controller.filtrar(this.props.location.pathname, this.props.filterValues)
        }
    }

    render() {
        return (
            <div className="filter-container">
                <form onSubmit={(event) => this.filtrar(event)} className="filter-box">
                    {this.props.children}
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <Button color="primary" type="submit">Filtrar</Button>
                            {" "}
                            {this.props.onExportExcel && (
                                <Button color="primary" onClick={() => this.props.onExportExcel()}>
                                    Exportar Excel
                                </Button>
                            )}
                        </Col>
                    </Row>
                </form>
            </div>
        )
    }
};

export default withRouter(TabelaFiltro)